import { useState, useCallback } from 'react';
import { OrderingForSaleService } from '../services/orderingForSale.service';
import { PaymentService } from '../services/payment.service';
import { ParametersForGetAccount } from '../interfaces/ordering/payment/parametersForGetAccount';
import { CreatePaymentInternetAcquiringOnParameters } from '../interfaces/ordering/payment/createPaymentInternetAcquiringOnParameters';
import { InternetAcquiringEnum } from '../interfaces/ordering/crm/internetAcquiringEnum';
import { ConfigServer } from '../configs/config.server';
import Router from 'next/router';
import { useCreateOrdering } from './useCreateOrdering';
import { CustomerPaymentState } from '../types/types';
import { OrderingForSaleProps } from '../components/main/detailsOrder.props';

export const usePay = (props: OrderingForSaleProps, config: ReturnType<typeof ConfigServer>) => {
  const [isLoading, setIsLoading] = useState(false);
  const createOrdering = useCreateOrdering(props, config);

  const payPrePayment = useCallback(async () => {
    setIsLoading(true);

    if (props.orderingPrePayment && props.orderingForSale) {
      try {
        const url = await OrderingForSaleService.getPayUrlInternetAcquiringOnOrdering(props.orderingPrePayment.orderingId, config.ServiceOrdering.GetPayUrlInternetAcquiringOnOrdering);

        if (url) {
          Router.push(url);
          return;
        }

        const parameters: CreatePaymentInternetAcquiringOnParameters = {
          accountNumber: props.orderingPrePayment.accountNumber,
          internetAcquiring: props.orderingPrePayment.internetAcquiring,
          orderingId: props.orderingPrePayment.orderingId,
          webSiteName: config.WebSitesName,
          isMobile: false,
        };

        const result = await PaymentService.createPaymentInternetAcquiringOnParametersOrdering(parameters, config.ServiceOrdering.CreatePaymentInternetAcquiringOnParametersOrdering);

        if (!result.isError && result.urlPay) {

          await PaymentService.updateOrderingPrePaymentLifeTime(props.orderingPrePayment.orderingId, config.ServiceOrdering.UpdateOrderingPrePaymentLifeTime);

          Router.push(result.urlPay);
        }
      } catch (error) {
        console.error('Payment pre payment error:', error);
        // Здесь можно добавить уведомление об ошибке для пользователя
      } finally {
        setIsLoading(false);
      }
    }
    else {
      setIsLoading(false);
    }
  }, [props, config]);

  const pay = useCallback(async (model: CustomerPaymentState) => {
    setIsLoading(true);

    try {
      const orderingForSale = { ...props.orderingForSale };

      if (orderingForSale.orderingId) {
        const url = await OrderingForSaleService.getPayUrlInternetAcquiringOnOrderingV2(orderingForSale.orderingId, InternetAcquiringEnum.Payler, config.ServiceOrdering.GetPayUrlInternetAcquiringOnOrderingV2);

        if (url) {
          Router.push(url);
          return;
        }
      }

      if (orderingForSale?.customer && !orderingForSale.orderingId) {
        orderingForSale.customer.email = model.email;
        orderingForSale.customer.firstName = model.firstName;
        orderingForSale.customer.lastName = model.lastName;

        const phoneDigits = model.phone.replace(/\D/g, '');
        orderingForSale.customer.phone = parseInt(phoneDigits, 10);
      }

      if (props.preOrderingId && !orderingForSale.orderingId) {
        const newOrderingId = await createOrdering(model);
        if (newOrderingId) {
          orderingForSale.orderingId = newOrderingId;
        }
      }

      const param: ParametersForGetAccount = {
        partnerId: orderingForSale.partnerId,
        webSitesShortName: config.WebSitesName,
      };

      const accountList = await PaymentService.getAccountsOnParameters(param, config.ServiceOrdering.GetAccountsOnParameters);

      const defaultAccount = accountList.find((item) => item.isDefault);
      if (!defaultAccount) {
        throw new Error('No default account found');
      }

      const paymentParams: CreatePaymentInternetAcquiringOnParameters = {
        accountNumber: defaultAccount.accountNumber,
        internetAcquiring: InternetAcquiringEnum.Payler,
        orderingId: orderingForSale.orderingId,
        webSiteName: config.WebSitesName,
        isMobile: false,
      };

      const result = await PaymentService.createPaymentInternetAcquiringOnParametersOrdering(paymentParams, config.ServiceOrdering.CreatePaymentInternetAcquiringOnParametersOrdering);

      if (!result.isError && result.urlPay) {
        Router.push(result.urlPay);
      }
    } catch (error) {
      console.error('Payment error:', error);
      // Здесь можно добавить уведомление об ошибке для пользователя
    } finally {
      setIsLoading(false);
    }
  }, [props, config, createOrdering]);

  return { pay, payPrePayment, isLoading };
};